// extracted by mini-css-extract-plugin
module.exports = {"currentitem":"AllContents_currentitem__1fXhK","text":"AllContents_text__2rMRS","items":"AllContents_items__2cVkJ","footer":"AllContents_footer__3D4cc"};